<template>
    <div class="chat-quote-message">
        <!-- <div v-if="isRecall" class="recall">{{ showNormalMessage(msgInfo.content) }}</div> -->
        <div v-if="isRecall" class="recall">(引用消息已被撤回)</div>
        <div v-if="!isRecall" class="send-user">
            {{ (showName || msgInfo.sendNickName) + ":" }}
        </div>
        <div v-if="!isRecall" class="quote-content">
            <span v-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT"
                v-html="quoteHtmlText"></span>
            <div v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
                <img class="quote-image" :src="contentData.thumbUrl" @click.stop="showFullImageBox" />
            </div>
            <div v-if="msgInfo.type == $enums.MESSAGE_TYPE.VIDEO">
                <video ref="videoPlayer" class="quote-video" controls preload="none" :poster="contentData.coverUrl"
                    :src="contentData.videoUrl" />
            </div>
            <div v-if="msgInfo.type == $enums.MESSAGE_TYPE.USER_CARD">
                <div class="quote-msg-card">
                    <div class="card-body">
                        <head-image :url="contentData.headImage" :name="contentData.nickName" radius="10%"
                            style="position: relative;" :isAddFriend="true" :id="contentData.userId" :isShowUserInfo="false"
                            :enable-group-at="false"></head-image>
                        <div class="name">{{ contentData.nickName }}</div>
                    </div>
                    <div class="card-tip">用户ID: {{ contentData.userId }}</div>
                </div>
            </div>
            <div v-if="msgInfo.type == $enums.MESSAGE_TYPE.GROUP_CARD">
                <div class="quote-msg-card">
                    <div class="card-body">
                        <head-image :url="contentData.headImage" :name="contentData.groupName" radius="10%"
                            style="position: relative;" :isAddFriend="true" :id="contentData.groupId"
                            :enable-group-at="false"></head-image>
                        <div class="name">{{ contentData.groupName }}</div>
                    </div>
                    <div class="card-tip">群ID: {{ contentData.groupId }}</div>
                </div>
            </div>
            <div v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO">
                <audio class="quote-audio" controls :src="contentData.url"></audio>
            </div>
            <div class="quote-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
                <div class="quote-file-info">
                    <el-link class="quote-file-name" :underline="true" target="_blank" type="primary"
                        :href="contentData.url" :download="contentData.name">{{ contentData.name }}</el-link>
                    <div class="quote-file-size">{{ fileSize }}</div>
                </div>
                <div class="quote-file-icon">
                    <span type="primary" class="el-icon-document"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatMessageHtml } from '@/utils/common';
import { resolveMediaUrlsInObject } from '@/utils/mediaUrl';
import HeadImage from '../common/HeadImage.vue';
export default {
    name: "chatQuoteMessage",
    props: {
        showName: {
            type: String,
            required: true
        },
        msgInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    components: {
        HeadImage
    },
    methods: {
        showFullImageBox() {
            let imageUrl = this.contentData.originUrl;
            if (imageUrl) {
                this.$store.commit('showFullImageBox', imageUrl);
            }
        },
        showNormalMessage(msg) {
            let message = msg;
            try {
                message = JSON.parse(msg)
                if (typeof message === 'object') {
                    message = '(消息已撤回)'
                }
            } catch (e) {
                console.error(e)
            }
            return message;
        },
    },
    computed: {
        quoteHtmlText() {
            return formatMessageHtml(this.msgInfo.content, '', 'emoji-small');
        },
        quoteMessageText() {
            return this.msgInfo.content + "hello";
        },
        contentData() {
            const parsed = JSON.parse(this.msgInfo.content);
            return resolveMediaUrlsInObject(parsed, this.$store.state.configStore.s3Url);
        },
        fileSize() {
            let size = this.contentData.size;
            if (size > 1024 * 1024) {
                return Math.round(size / 1024 / 1024) + "M";
            }
            if (size > 1024) {
                return Math.round(size / 1024) + "KB";
            }
            return size + "B";
        },
        isRecall() {
            return this.msgInfo.status == this.$enums.MESSAGE_STATUS.RECALL
        }
    }
}
</script>

<style lang="scss">
.chat-quote-message {
    background: #eee;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    border-radius: 8px;
    font-size: var(--im-font-size-smaller);
    color: var(--im-text-color-light);

    .send-user {
        margin-right: 10px;
        font-weight: 600;
        min-width: fit-content;
    }

    .quote-content {
        .quote-image {
            min-width: 40px;
            min-height: 30px;
            max-width: 80px;
            max-height: 60px;
            cursor: pointer;
        }

        .quote-video {
            min-width: 80px;
            min-height: 60px;
            max-width: 160px;
            max-height: 120px;
            cursor: pointer;
        }

        .quote-audio {
            height: 38px;
        }


        .quote-file {
            display: flex;
            flex-wrap: nowrap;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            padding: 2px 15px;

            .quote-file-info {
                flex: 1;
                height: 100%;
                text-align: left;
                font-size: 14px;
                margin-right: 10px;

                .quote-file-name {
                    display: inline-block;
                    min-width: 160px;
                    max-width: 220px;
                    font-size: 14px;
                    margin-bottom: 4px;
                    white-space: pre-wrap;
                    word-break: break-all;
                }

                .quote-file-size {
                    font-size: var(--im-font-size-smaller);
                    color: var(--im-text-color-light);
                }
            }

            .quote-file-icon {
                font-size: 32px;
                color: #d42e07;
            }

        }

        .quote-msg-card {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            border-radius: 5px;
            padding: 12px 10px;
            width: 220px;
            position: relative;
            box-shadow: var(--im-box-shadow-dark);
            margin-top: 3px;

            // cursor: pointer;
            .card-body {
                flex: 1;
                display: flex;
                align-items: center;
                border-bottom: 3px solid #eee;
                position: relative;
                gap: 10px;
                padding-bottom: 12px;

                .name {
                    font-weight: 600;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: var(--im-text-color-light);
                    font-size: var(--im-font-size-small);
                }
            }

            .card-tip {
                margin-top: 6px;
                text-align: left;
                color: var(--im-text-color-light);
                font-size: var(--im-font-size-small);
            }
        }

    }
}
</style>